import MediaTypeImage from "./MediaTypeImage";

export { MediaTypeImage };
export default { MediaTypeImage };
